<template>
  <div class="row form-group">
    <label :class="labelClasses">{{ label }}</label>
    <div class="col-auto form-right-input" style="margin-top:4px;height:32px;">
      <span :class="valueClass">{{ value }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: ['label', 'value', 'labelClass', 'valueClass', 'disabled'],
  computed: {
    labelClasses () {
      let out = 'col-form-label form-left-header'
      if (this.labelClass) {
        out += ` ${this.labelClass}`
      }
      if (!out.includes(' width-')) {
        out += ' width-115'
      }
      if (this.disabled) {
        out += ' subtle'
      }
      return out
    }
  }
}
</script>
